module.exports = __webpack_public_path__ + "img/logo1.f3e52724.png";